import ChangeHistoryContainer from './ChangeHistoryContainer';

export default { ChangeHistoryContainer };
